import { withAuthGate } from '@sunrise-ui/composites';
import { isNative, useSafeLocalSearchParams } from '@sunrise-ui/primitives';
import { EventLandingView } from '@templates/EventLandingView';
import React from 'react';

/**
 * Event Details Screen - Landing page for a specific event
 *
 * Displays event information including:
 * - Hero header with image, title, date, location
 * - "Get Tickets" / "View My Ticket" button
 * - About section with event description
 * - Agenda section (for multi-session events)
 * - Location section with map link
 */
export function EventDetailsScreen() {
  const { slug } = useSafeLocalSearchParams<{
    slug: string;
  }>();

  return <EventLandingView slug={slug} />;
}

export default withAuthGate(EventDetailsScreen, { requireAuth: isNative });
